// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__CGT5d","footer":"ChangeClinic_footer__2w32H"};